import { restApiDP } from "@plannel/services/utils/rest-api";

/**
 * Demand Netting — DP 의 신규 네팅.
 *
 * 확정 수주(SO)와 겹치는 만큼을 수요계획에서 걷어내고 잔여 예측을 남긴다.
 * 레거시 "수요 감안"(상한 대체)과는 설정 한 행의 MODE 로 갈린다 — 동시에 켜질 수 없다.
 */

/** 사용 여부 · 모드 · 기본 옵션. 화면이 뜰 때 한 번 읽는다. */
const getConfig = () => {
  return restApiDP.post("/api/dp/demand-netting/config");
};

/**
 * 네팅 실행. 해당 버전 결과를 전량 지우고 다시 만든다.
 *
 * 기간을 넘기지 않으면 버전의 계획 기간 전체로 돈다. [전 구간] 범위는 전체에서 차감하므로
 * 기간을 좁히면 결과 자체가 달라진다.
 */
const execute = (params) => {
  return restApiDP.post("/api/dp/demand-netting/execute", params);
};

/** 결과 조회. 화면은 이 칸들로 품목 x 거래처마다 5행을 만든다. */
const getResult = (params) => {
  return restApiDP.post("/api/dp/demand-netting/result", params);
};

/** 노트가 달린 조합만 골라 돌려준다. 조합마다 묻지 않으려고 한 번에 보낸다. */
const getNotedKeys = (params) => {
  return restApiDP.post("/api/dp/demand-netting/notes", params);
};

const demandNettingService = {
  getConfig,
  execute,
  getResult,
  getNotedKeys
};

export default demandNettingService;
